export default class EmployeeDayPlanItem {
  constructor() {
    this.TargetUserId = 0;
    this.StartDate = new Date();
    this.EndDate = new Date();
    this.Location = 'office';
    this.WorkingHours = 8;
    this.AbsenceType = '';
    this.AbsenceHours = 0;
    // Mirrors EmployeeDayPlan.Status; the panel derives the absence-locked state from it (approved = locked).
    this.Status = 'planned';
  }
}
